module.exports = __webpack_public_path__ + "static/media/chart.b5c255fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/chart.svg
// module id = ./src/assets/icons/chart.svg
// module chunks = 0